import { useMemo } from 'react'

export const usCaPostalCodesRegEx =
  /^(\d{5}|\d{5}-\d{2}[A-Za-z]{2}|\d{5}-\d{4}|[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d|\s?[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d)$/

export const caPostalCodesRegEx =
  /^([A-Za-z]\d[A-Za-z]\d[A-Za-z]\d|\s?[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d)$/

export const useLocalisedValidations = () => {
  const validatePostalCode = useMemo(() => {
    return (postalCode: string) => {
      if (!usCaPostalCodesRegEx.test(postalCode)) {
        return 'Invalid Postal Code'
      }
      return undefined
    }
  }, [])

  const validateMultiplePostalCode = useMemo(() => {
    return (codes: string[], match?: boolean) => {
      return codes.filter((e) => {
        return match
          ? e.match(usCaPostalCodesRegEx)
          : !e.match(usCaPostalCodesRegEx)
      })
    }
  }, [])

  const validateCanadianPostalCode = useMemo(() => {
    return (postalCode: string | null) => {
      return postalCode ? caPostalCodesRegEx.test(postalCode) : false
    }
  }, [])

  return {
    validatePostalCode,
    validateMultiplePostalCode,
    validateCanadianPostalCode,
  }
}
